import sdkTool from "If_AdTool/common/sdkTool";
function getRemPageFont() {
    if (document.documentElement.style.fontSize) {
        return document.documentElement.style.fontSize.replace("px", "");
    }
    return 0
}
/***
 * 频道首页浮动05
 * ***/
function renderFn(el,data) {
    // 第二次打开执行一下代码，
    // 获取页面打开次数，若不存在则初始化为 0
    // 获得当前日期 类似  yyyy-mm-dd    

    // const now = new Date();
    // const curDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

    // // 统一使用一个 key 存储每日打开次数
    // const singleKey = "pageOpenCountfloat5day";
    // // 从 localStorage 中获取存储的对象，若不存在则初始化为空对象
    // let allOpenCounts = JSON.parse(localStorage.getItem(singleKey)) || {};
    // // 获取当前日期的打开次数，若不存在则初始化为 0
    // let openCount = allOpenCounts[curDate] || 0;
    // if (openCount==0){
    //     allOpenCounts ={};
    // }
    // // 增加打开次数
    // openCount++;
    // // 更新当前日期的打开次数
    // allOpenCounts[curDate] = openCount;
    // // 存储更新后的所有日期的打开次数
    // localStorage.setItem(singleKey, JSON.stringify(allOpenCounts));

    //其他情况执行此代码
    let city = sdkTool.cookie('city');
    if (window.location.href.indexOf("AD___PREVIEW=1") != -1 || city != '010') {
        if (IfengAmgr.isShowPcBottom) return
        // 第二次打开执行以下代码
        let w= 1000;
        if (['finance.ifeng.com','tech.ifeng.com'].indexOf(window.location.hostname) != -1){
            if (getRemPageFont()>1){
                w = getRemPageFont() *100;
            }
        }
        let tuid = 'u7003433';
        if (window.location.pathname!='/'){
           // tuid = 'u7003445';
        }
        IfengAmgr.isShowPcBottom = true;
        // 这里可以添加第二次打开时的特殊逻辑
        IfengAmgr.setAdElContent({
            ap: 9060, code: JSON.stringify({
                "data": {
                    "tuid": tuid,
                },
                "script": "pc_bottom.js",
                "callback": "pc_bottom"
        }), el:document.body, w:w, h:130, encode: false })
    } 
    IfengAmgr.show(el, data)
}
if (typeof window.IfengAmgr != undefined) {
    window.IfengAmgr.tplLib.indexyg = { render: renderFn, version: "1.0.1" };
}